import React from 'react';
import cn from 'classnames';
import Icon from 'components/UI/Icon';
import LazyImage from 'components/UI/LazyImage';

import * as styles from './MobileCard.module.scss';

export default function MobileCard({
  cover,
  title,
  expert,
  expertPosition,
  active,
  isThemeDark,
  handleClick,
}) {
  return (
    <article className={styles.card}>
      <div className={cn(styles.innerLayout, active && styles.current, isThemeDark && styles.dark)}>
        <div role="button" className={styles.pictureWrapper} onClick={handleClick}>
          <LazyImage src={cover} className={styles.picture} alt={title} loading="eager" />
          <Icon name="video-play-circle" className={styles.playIcon} />
          <h4 className={styles.title}>{title}</h4>
        </div>
        <div className={styles.text}>
          <div className={styles.name}>{expert}</div>
          <p className={styles.position}>{expertPosition}</p>
        </div>
      </div>
    </article>
  );
}
